export default
    () => {
        return {
            zcierres: [],
            zcierresAbiertos: []
        }
    }
